import '../chat/chat.css';
import React, { useState, useEffect, useRef } from 'react';
import pisi from'../../images/pisi.png'
import gideon from'../../images/Gideon.jpg'
import send from'../../images/send.png'

function Chat({mess, from, goNext, goMenu, setFailedGame, gallery, setGallery}) {
  const [messages, setMessage] = useState([]);
  const [answers, setAnswers] = useState();
  const [myAnswers, setMyAnswers] = useState([]);
  const [opacity, setOpacity] = useState(0);
  const [white, setWhite] = useState(1);
  const [typing, setTyping] = useState(false);
  const [opType, setOpType] = useState(0);
  const [messNum, setMessNum] = useState(0);
    const [next, setNext] = useState();
    const [index, setIndex] = useState(20);
  const inputRef = useRef(null);
  let answered;

  useEffect(() => {
    start(messNum);
    changeWhite(true);
},[]);
useEffect(() => {
  if(inputRef.current != null){
  inputRef.current.addEventListener('keydown', function(e) {
  if(e.keyCode === 13) {
  check();
  }
  });
}
},[inputRef.current]);

useEffect(() => {
  var d = document.getElementById('messages');
console.log(d.scrollHeight);
console.log(d.clientHeight);

if(d.scrollHeight > d.clientHeight) {
d.scrollTop = d.scrollHeight - d.clientHeight;
}
});

async function go(){
  setIndex(20);
  await changeWhite();
  goNext();
}

async function goToMenu(){
  setIndex(20);
  await changeWhite();
  goMenu();
}
function changeOnOff(toLow, setter){
  return new Promise((resolve, reject) => {
  if(toLow){
    var op=1;
    change(toLow);
  }else{
    var op=0;
    change();
  }
  function change(toLow){
  if(toLow){
    if(op>0){
      op-=0.03;
    setter(op);
    setTimeout(ChangetoLow, 10);
  }else{
    resolve();
    setIndex(14);
    return;
  }
}else{
  if(op<1){
    op+=0.03;
  setter(op);
  setTimeout(change, 10);
}else{
  resolve();
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
});
}
function changeWhite(toLow){
  return new Promise((resolve, reject) => {
  if(toLow){
    var op=1;
    change(toLow);
  }else{
    var op=0;
    change();
  }
  function change(toLow){
      console.log(opacity);
        console.log(op);
  if(toLow){
    if(op>0){
      op-=0.03;
    setWhite(op);
    setTimeout(ChangetoLow, 10);
  }else{
    resolve();
    setIndex(14);
    return;
  }
}else{
  if(op<1){
    op+=0.03;
  setWhite(op);
  setTimeout(change, 10);
}else{
  resolve();
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
});
}



async function myAnswer(e){
await ans();


  function ans(){
        return new Promise((resolve, reject) => {
            setIndex(18);
            changeOpacity(true);
            setMessage([...messages, {text:e.target.innerHTML, from: 'messageFromMe'}]);
            answered=e.target.innerHTML;
            start(messNum);
            resolve();
          });
        }
}

function waitin(){
  return new Promise((resolve, reject) => {
    document.getElementById("wrap").onclick=ff;
function ff(){
  resolve();
}
  });
}



async function check(){
  var crypto = require('crypto');
  const sha256 = x => crypto.createHash('sha256').update(x.toLowerCase(), 'utf8').digest('hex');
  setMessage((prev) => [...prev,{text:inputRef.current.value, from:'messageFromMe'},]);
  if(inputRef.current.value.length < 7){
if(sha256(inputRef.current.value) === "837dbfe793d67b893ca200e13b719b0943dcce6076172c43b34eba45992ebbfd"){
  setMessNum(8);
  start(8);

  localStorage.setItem('failedGame', 0);
  setFailedGame(0);
  await changeOnOff(true,setOpType);
  setTyping(false);
}else{
  await changeOnOff(true,setOpType);
  setTyping(false);
  await typAnim(2 , {text:"Nope",from:'messageFromThem', name:"Gideon", avatar:gideon}, {text:"",from:'messageFromMe'});
  await typAnim(1 , {text:"You got other options",from:'messageFromThem', name:"Gideon", avatar:gideon}, {text:"Неа",from:'messageFromThem', name:"Gideon", avatar:gideon});

  setMessNum(33);
  start(33);
}
}else{
  await changeOnOff(true,setOpType);
  setTyping(false);
  await typAnim(2 , {text:"Nope",from:'messageFromThem', name:"Gideon", avatar:gideon}, {text:"",from:'messageFromMe'});
  await typAnim(1 , {text:"You got other options",from:'messageFromThem', name:"Gideon", avatar:gideon}, {text:"Неа",from:'messageFromThem', name:"Gideon", avatar:gideon});

  setMessNum(33);
  start(33);
}
}

async function start(startingFrom){
  for(let i=startingFrom;i<mess.length;i++){
    if(mess[i].answered){
      if(answered !== mess[i].answered){
        if(mess[i].endofAnswer){
          answered=undefined;
        }
        continue;
      }
      if(mess[i].endofAnswer){
        answered=undefined;
      }
    }
    if(mess[i].asking){
      setTyping(true);
      changeOnOff(false,setOpType);
      break;
    }
    let delay;
    if(mess[i].img){
      delay = 3;
    }else{
      delay = Math.floor(mess[i].text.length / 40);
      if(delay===0) delay=1;
      console.log(delay)
    }
await typAnim(delay, mess[i], mess[i-1]);
delay=0;
setMessNum(i+1);
await waitin();
if(mess[i].answers){
  break;
}
if(mess[i].endOfChat){
  break;
}
if(mess[i].skipAnswers){
  answered=undefined;
}
  }
}

function changeOpacity(toLow){
  if(toLow){
    var op=1;
    change(toLow);
  }else{
    var op=0;
    change();
  }
  function change(toLow){
      console.log(opacity);
        console.log(op);
  if(toLow){
    if(op>0){
      op-=0.1;
    setOpacity(op);
    setTimeout(ChangetoLow, 20);
  }else{
    setAnswers(undefined);
    return;
  }
}else{
  if(op<1){
    op+=0.1;
  setOpacity(op);
  setTimeout(change, 20);
}else{
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
}
  function typAnim(end,message, prevMessage){
    return new Promise((resolve, reject) => {
    let i=0,j=0;
    if(message.img && message.gallery){
      let newGallery = new Map(gallery)
      if(gallery.has(message.img)){
        newGallery.set(message.img, '1');
        localStorage.setItem('gallery', JSON.stringify(Array.from(newGallery.entries())));
        setGallery(newGallery);
      }
    }
    if(message.from === 'messageFromMe'){
      j=end;
    }
    anim();
    async function anim(){
      try{
      if(j===end){
        if(message.from ==="messageFromThem"){
            if(prevMessage){
          if(message.avatar === prevMessage.avatar){
            let cloneMessage = {};
            for (let key in message) {
              cloneMessage[key] = message[key];
            }
            setMessage((prev) => {
              let cloneOfPrevObj = {};
              let clonePrev = [...prev]
              for (let key in prev[prev.length-1]) {
                cloneOfPrevObj[key] = prev[prev.length-1][key];
              }
              clonePrev.pop();
  cloneOfPrevObj.avatar = false;
  cloneMessage.name = false;
  return [...clonePrev, cloneOfPrevObj, cloneMessage];});
}else{
  setMessage((prev) => [...prev, message]);
}
      }else{
          setMessage((prev) => [...prev, message]);
        }

      }else{
        setMessage((prev) => [...prev, message]);
      }

        if(message.answers){
          setIndex(14);
          document.getElementById('typ').innerHTML = "5 members";
          await waitin();
          setAnswers(message.answers);
          changeOpacity(false);
        }
        if(message.endOfChat){
          setTimeout(setNextWithDelay, 2000)
        }
        function setNextWithDelay(){
          setIndex(14);
          setNext({text: message.endOfChat.text});
        }
        document.getElementById('typ').innerHTML = "5 members";
          resolve()
          return;

        }
      if(i===0){
        if(message.img){
          document.getElementById('typ').innerHTML = message.name + " is sending a photo...";
        }else{
          document.getElementById('typ').innerHTML = message.name + " is typing...";
        }
  i++;
    setTimeout(anim,200);
  return;
}
if(i===1){
  if(message.img){
    document.getElementById('typ').innerHTML = message.name + " is sending a photo.";
  }else{
    document.getElementById('typ').innerHTML = message.name + " is typing.";
  }
i++;
  setTimeout(anim,200);
    return;
}
if(i===2){
  if(message.img){
    document.getElementById('typ').innerHTML = message.name + " is sending a photo..";
  }else{
    document.getElementById('typ').innerHTML = message.name + " is typing..";
  }
  j++;
  i=0;
    setTimeout(anim,200);
  return;
}
}catch(e){
  console.log(e);
}
}
});
  }
  return (
<div className='wrap'>
{next && <div className='nextDay' onClick={go}><p>{next.text}</p></div>}
{typing && <div className='type' style={{opacity:opType}}><input type='text' placeholder='Message' ref={inputRef}/><img src={send} onClick={check}/> </div>}
<div className='clickWrap' id='wrap' style={{opacity:white,zIndex:index}}></div>
{ answers &&
<div className='answers' style={{opacity:opacity}}>
{answers.map((item,index)=>{
  return (
    <div className='answer' onClick={myAnswer} name={index} key={index}>{item}</div>
  )
})}
</div>
}
<img src={pisi} className='logo'/>
<div className='topLine'>
<div className="arrow1" onClick={goToMenu}>
    <div></div>
</div>
<div className='pict'>
  <img className='img' src={from.photo} alt="" />
</div>
<div>
<p className='nameofchat'>{from.name}</p>
<p className='typ' id="typ">Online</p>
</div>

</div>
<div id='back'></div>
<div className='messages' id='messages'>
{ messages.map(function (item, index) {
return(
  <div className={"container"+item.from} key={index}>
  {item.avatar && <div className='avatar'>
    <img className='img' src={item.avatar} alt="" />
  </div>}
  <div className={item.from}>
  {item.name && <><div className="memberNameWrap"></div><p className="memberName">{item.name}</p></>}
  <div className={item.from+'Under'}></div>
  {item.text && <p className="comment_text1">{item.text}</p>}
  {item.img && <img src={item.img} height={item.height} style={{clear:"both",float:"left"}} max-width='100%'/>}
  </div>
  </div>
);

})
}
</div>
</div>
  );
}

export default Chat;
